import { Component } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiService } from './services/api.service';
import { TitleService } from './services/title.service';
import { environment } from '../environments/environment';

declare let gtag: Function;
@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  constructor(private apiService: ApiService, private titleService: TitleService, private router: Router, private activatedRoute: ActivatedRoute) {
    if (environment.production) {
      /** Google Analytics **/
      const script2 = document.createElement('script');
      script2.async = true;
      script2.type = 'text/javascript';
      script2.innerHTML = `window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }`;
      document.head.prepend(script2);
      const script1 = document.createElement('script');
      script1.async = true;
      script1.type = 'text/javascript';
      const gaLink = 'https://www.googletagmanager.com/gtag/js?id=' + environment.ga_code;
      script1.src = gaLink;
      document.head.prepend(script1);
    }

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((route: any) => {
      this.titleService.setTitle(this.activatedRoute.snapshot, this.router.routerState.snapshot);
      if (environment.production) {
        gtag('js', new Date());
        gtag('config', environment.ga_code);
        gtag('event', 'page_view', {
          page_title: this.titleService.getTitle(),
          page_path: route.urlAfterRedirects,
          page_location: this.router.url,
        });
      }
    });
  }
}
